<template>
  <core-image-component
    :class="$style.root"
    :style="`--width-in-mm: ${widthInMm}`"
    :image="image"
  />
</template>

<script lang="ts" setup>
const props = defineProps({
  image: {
    type: Object
  },
  widthInMm: {
    type: [Number, String],
    required: false
  }
})
</script>

<style module>
.root {
  --width--reference: 420;
  --width--max: max(var(--width--reference), var(--width-in-mm, 0));

  --width--min: max(calc((var(--width-in-mm, 0) / var(--width--reference)) * 100%), 50%);
  --width: min(var(--width--min), 100%);

  width: var(--width);

  margin: 0;
  margin-left: auto;
  margin-right: auto;

  pointer-events: none;

  position: relative;
}

.root:before {
  content: '';
  display: block;
  position: absolute;
  inset: 0;
  z-index: 1;
  background-color: rgba(0, 0, 0, 0.05);
}
</style>
